import React from "react";
import ProductListPriceCell from "../../pages/products/ProductListPriceCell";
import { putApi } from "../../helpers/auth_helpers";
import { PickerProduct } from "./productSelection";

export default function InventoryProductPrices({ product, onSaved }: { product: PickerProduct; onSaved: (product: PickerProduct) => void }) {
  const draft = product.priceEditsRequirePublish && product.hasDraftChanges ? product.draft : null;
  const sellPrice = draft && "sellPrice" in draft ? draft.sellPrice : product.sellPrice;
  const costPrice = draft && "costPrice" in draft ? draft.costPrice : product.costPrice;
  const save = async (sell: string, cost: string) => {
    let response: any;
    try {
      response = await putApi(`${process.env.REACT_APP_SERVERURL || ""}/product/prices`, { id: product._id, sellPrice: sell, costPrice: cost });
    } catch {
      throw new Error("We couldn’t confirm the save. Check your connection, then reload to check the prices before trying again.");
    }
    if (response?.success !== true) {
      const permission = response?.status === 403 || /studio|permission|authorized/i.test(response?.message || "");
      throw new Error(permission ? "You don’t have permission to edit this Product’s prices. Ask a studio administrator." : "Prices weren’t saved. Check the amounts and try again.");
    }
    onSaved(product.priceEditsRequirePublish
      ? { ...product, hasDraftChanges: true, draft: { ...product.draft, sellPrice: sell, costPrice: cost } }
      : { ...product, sellPrice: sell, costPrice: cost });
  };
  return <div className="hkp-inventory-prices">
    {product.canEditPrices === true && product._id ? <ProductListPriceCell explicitSave sellPrice={sellPrice} costPrice={costPrice} onCommit={save} /> : <>
      <div><strong>Selling Price:</strong> {String(sellPrice ?? "").trim() || "Not priced"}</div>
      <div><strong>Cost Price:</strong> {String(costPrice ?? "").trim() || "Not entered"}</div>
      <small>Read only. Ask a studio administrator to change prices.</small>
    </>}
    {product.priceEditsRequirePublish && <small>Price edits are saved to the Product draft. Publish the Product to update inventory filters.</small>}
  </div>;
}
